import { removeAutopilotEmoji } from "#webapp/src/util/event.util";
import getRecurranceEnum from "#webapp/src/util/getRecurranceEnum";
import getTimeDescription from "#webapp/src/util/getTimeDescription";
import isTimeRangeFlexibilityEditable from "#webapp/src/util/isTimeRangeFlexibilityEditable";
import isTimeRangeFlexible from "#webapp/src/util/isTimeRangeFlexible";
import getDuration from "../../../util/getDuration";
import { OneOnOnesQueryQuery } from "../graphql/__generated__/OneOnOnes.generated";

const parseOneOnOnesGQL = (data: OneOnOnesQueryQuery | undefined) => {
  const dataObj =
    data?.viewer?.user?.orgs?.edges?.[0]?.node?.flexibleMeetingsDashboard?.myOneOnOnes;

  return (
    dataObj?.map((datum) => ({
      id: datum.id,
      duration: getDuration(datum),
      conflicted: false, // DevNote: GQL does not currently support looking up conflicted status at this time
      editable: isTimeRangeFlexibilityEditable(datum),
      flexible: isTimeRangeFlexible(datum),
      title: removeAutopilotEmoji(datum.title) || "Untitled Event",
      recurrance: getRecurranceEnum(datum),
      recurrenceText: getTimeDescription(datum),
    })) || []
  );
};

export default parseOneOnOnesGQL;
